import { Component, OnInit, Input, HostListener, SimpleChanges, OnChanges, Output, EventEmitter, PLATFORM_ID, Inject, ViewEncapsulation } from '@angular/core';
import { MktCardRetrievalService } from '../../../core/services/mkt-card-retrieval.service';
import { isPlatformBrowser } from '@angular/common';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';

type AvailableSizes = 'tiny' | 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'app-card-art',
  templateUrl: './card-art.component.html',
  styleUrls: ['./card-art.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})

export class CardArtComponent implements OnInit, OnChanges {
  private allCardContent: any = null;
  public imageSize: AvailableSizes = 'lg';

  public cardInfo: any;
  public imageLink: string;
  public imageUrl: string;

  // enable/disable clickable card-art
  @Input() linkHref: string;
  @Input() linkTarget: ('_self' | '_blank') = '_self';
  @Input() enablePdpLink = true;
  @Input() linkPreventDefault = true;
  @Input() tabIndex = 0;

  // Used to set preferred image size based off of screen size
  @Input() desktopSize: AvailableSizes;
  @Input() tabletSize: AvailableSizes;
  @Input() mobileSize: AvailableSizes;
  @Input() defaultSize: AvailableSizes;

  // Used to set card
  @Input() pid;
  @Input('cardName') internalCardName;
  @Input('imgCache') imgCache:boolean = true;
  // AriaLabel munipulation
  @Input() ariaLabelPrepend = '';
  @Input() ariaLabelAppend = '';
  public altText = '';

  // Handles click and enter when link is enabled
  @Output() clicked = new EventEmitter();
  imagePrefix: any;

  // Set image priority to load, (LCP images should take priority)
  @Input() priority = false;
  // Set defult size as lg
  width = 222;
  height = 140;
  style = 'width:341px;height:215px;text-align:center;display:inline-block;'
  constructor(
    private cardRetrievalService: MktCardRetrievalService,
    private mktEnvironmentService: MktEnvironmentService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.imagePrefix = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
   }

  ngOnInit() {
    this.initilize();
  }

  private initilize() {
    if (!isPlatformBrowser(this.platformId)) return;
    if (!this.allCardContent) {
      this.allCardContent = this.cardRetrievalService.allCardContent;
    }

    if (this.pid) {
      this.cardInfo = this.cardRetrievalService.getCardByPid(this.pid);
    } else if (this.internalCardName) {
      this.cardInfo = this.cardRetrievalService.getCardByName(this.internalCardName);
    }

    // Set alt text for image
    let altText = this.cardInfo?.cardName;
    if (this.ariaLabelPrepend) { altText = this.ariaLabelPrepend + ' ' + altText; }
    if (this.ariaLabelAppend) { altText = altText + ' ' + this.ariaLabelAppend; }
    this.altText = altText;

    this.setCardImageUrl();
    this.setLinkAndURL();
  }

  ngOnChanges():void {
    this.initilize();
  }

  private setCardImageUrl() {
    // Check for card content and predefined properties
    if (!this.cardInfo || !this.allCardContent) { return; }

    this.getImageSize();

    // Extract data needed to build the image url
    const { path, sizes, extension } = this.allCardContent;
    const { internalCardName } = this.cardInfo || <any>{};

    // Set the image url
    this.imageUrl = `${this.imagePrefix}${path}${internalCardName}/${internalCardName}_${sizes[this.imageSize]}.${extension}`;
    this.width = sizes[this.imageSize]?.split('x')[0] || this.width;
    this.height = sizes[this.imageSize]?.split('x')[1] || this.height;
    this.style = this.priority ? '' :`width:${this.width}px;height:${this.height}px;text-align:center;display:inline-block;`
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setCardImageUrl();
  }

  private getImageSize() {
    // Wait for size to be set
    if (!this.desktopSize && !this.tabletSize && !this.mobileSize && !this.defaultSize) { return; }

    // SSR safe, set window.innerWidth to 1267 to load large image.
    const windowWidth = window ? window.innerWidth : 1267;

    // Set priority based upon screen size
    if (windowWidth > 1266) {
      // Desktop
      this.imageSize = this.desktopSize || this.defaultSize || this.tabletSize || this.mobileSize || 'lg';
    } else if (windowWidth > 767) {
      // Tablet
      this.imageSize = this.tabletSize || this.desktopSize || this.defaultSize || this.mobileSize || 'md';
    } else {
      // Mobile
      this.imageSize = this.mobileSize || this.tabletSize || this.desktopSize || this.defaultSize || 'sm';
    }
  }

  handleClicked(event) {
    if (this.linkPreventDefault) { event.preventDefault(); }

    this.clicked.emit(event);
  }

  private setLinkAndURL(): void{
    if(this.linkHref && this.imageLink !== this.linkHref){
      this.imageLink = this.linkHref;
    }else if(this.enablePdpLink && !this.imageLink){
      this.imageLink = this.cardInfo?.pdpUrl;
    }
  }
}
